<div mat-dialog-title>
    <mat-icon>warning</mat-icon>
    <h1>{{ 'CheckEmploymentHistoryDialog.Message' | translate }}</h1>
</div>
<mat-dialog-actions>
  <button mat-raised-button mat-dialog-close color="primary">{{ 'CheckEmploymentHistoryDialog.CloseButton' | translate }}</button>
</mat-dialog-actions>